export default __webpack_public_path__ + "static/media/icon-backward-skip.cac2c360.svg";